import { noop } from "lodash";
import Tooltip from "rc-tooltip";
import React from "react";
import { useLocations } from "../context/locations";
import { useToast } from "../context/toast";
import { useTransmitScales } from "../context/transmitScales";
import useTransmitScaleConfig from "../utils/useTransmitScaleConfig";
import TrashIcon from "./icons/TrashIcon";

interface Props {
  id: string;
  afterDelete?: () => void;
}

const DeleteLocationButton: React.FC<Props> = ({ id, afterDelete = noop }) => {
  const { setModalWarningConfig } = useToast();
  const { removeLocations } = useLocations();
  const { isTransmitScaleActive } = useTransmitScales();
  const toggleIsActive = useTransmitScaleConfig(
    (state) => state.toggleIsActive
  );

  return (
    <Tooltip placement="top" overlay="Remove location">
      <TrashIcon
        className="ml-2 h-6 w-6 text-gray-400 hover:text-gray-500 cursor-pointer dark:hover:text-gray-300"
        onClick={() => {
          setModalWarningConfig({
            open: true,
            resolve: () => {
              if (isTransmitScaleActive(id)) {
                toggleIsActive(id);
              }
              removeLocations([id]);

              afterDelete();
            }
          });
        }}
      />
    </Tooltip>
  );
};

export default DeleteLocationButton;
